export const INITIAL = {
	MODAL: {
		content: '',
		data: {},
	},
	VALUES: {
		name: '',
		description: '',
		attribute: 'FOR',
		usable: false,
		level: 1,
	},
	LIST: {
		columns: {
			name: 'Nome',
			description: 'Descrição',
			attribute: 'Atributo',
			level: 'Nível',
		},
		rows: [],
	}
}